import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpApiService} from './http-api.service';

@Injectable({
  providedIn: 'root'
})
export class ReleasePlanApiService {
  private readonly changeStateReservationEndpoint = 'release_plan/change_etat_reser';
  private readonly updateCommentProgWeekEndpoint = 'release_plan/update_progweek_infos';

  constructor(private httpApiService: HttpApiService) {
  }

  public changeStateReservation(cookies: string, idReservation: number, stateReservation: number): Observable<any> {
    const params = {
      etat_reser: stateReservation,
      id_reser: idReservation,
    };
    return this.httpApiService.post<any>(this.changeStateReservationEndpoint, params, cookies);
  }

  public updateCommentProgWeek(cookies: string, idWeek: number, comment: string): Observable<any> {
    const params = {
      id_week: idWeek,
      comment: comment,
    };
    return this.httpApiService.post<any>(this.updateCommentProgWeekEndpoint, params, cookies);
  }
}
